import { Box, InputAdornment, TextField } from '@mui/material';
import React, { SetStateAction, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { UserData } from 'interfaces/UserData.interface';

interface ISearchBar {
  users: UserData[];
  setQueriedUsers: SetStateAction<any>;
}

const SearchBar = ({ users, setQueriedUsers }: ISearchBar) => {
  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setQueriedUsers(
      users.filter(user =>
        user.username.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  useEffect(() => {
    setQueriedUsers(users);
    //eslint-disable-next-line
  }, [users]);

  return (
    <Box margin={4}>
      <TextField
        onChange={e => onChange(e)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'white' }} />
            </InputAdornment>
          ),
        }}
        fullWidth
        sx={{ input: { color: 'white' } }}
        id="standard-basic"
        placeholder="Search Users"
        variant="standard"
      />
    </Box>
  );
};

export default SearchBar;
